import { Dispatch, RefObject, SetStateAction } from 'react';

import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { IconButton } from '@mui/material';

import { CissTextField } from 'components/fields';
import { useBreakpoints } from 'hooks/useBreakpoints';

type MenuModulesSearchField = {
    query: string;
    setQuery: Dispatch<SetStateAction<string>>;
    ref?: RefObject<HTMLInputElement | null>;
};

/**
 * Campo de busca para o menu.
 */
export function MenuModulesSearchField({ query, setQuery, ref }: MenuModulesSearchField) {
    const { isUpMd } = useBreakpoints();

    return (
        <CissTextField
            inputRef={ref}
            size="small"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            fullWidth
            placeholder="Buscar módulo..."
            onKeyDown={(e) => e.stopPropagation()}
            slotProps={{
                input: {
                    startAdornment: <SearchOutlinedIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 20 }} />,
                    endAdornment: query ? (
                        <IconButton size="small" onClick={() => setQuery('')} sx={{ p: 0.25 }}>
                            <ClearOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                        </IconButton>
                    ) : null,
                    sx: {
                        px: 1,
                        fontSize: '1rem',
                        minHeight: isUpMd ? undefined : 44,
                    },
                },
            }}
        />
    );
}
